import { createVuetify } from 'vuetify';
import 'vuetify/styles';
import '@mdi/font/css/materialdesignicons.css';
import { icons } from './icons';
import { applyDomainFonts } from './fonts';
import { defaultTheme, themes } from './themes';

applyDomainFonts();

const vuetify = createVuetify({
  display: {
    thresholds: {
      xs: 0,
      sm: 600,
      md: 1024,
      lg: 1280,
      xl: 1920,
    },
  },
  theme: {
    defaultTheme,
    themes,
  },
  icons,
});

export default vuetify;
